import * as defaultImport from "@splunk/visualizations/ParallelCoordinates";
export * from "@splunk/visualizations/ParallelCoordinates";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
